import React from "react";
import {
  FaCompressAlt,
  FaEyeSlash,
  FaExpandAlt,
  FaFilter,
  FaSearch,
  FaSortAmountDown,
  FaStar,
  FaTimes,
} from "react-icons/fa";

import { CLIENT_SORT_OPTIONS } from "../data/suiviClientsData";

export default function SuiviClientsToolbar({
  filters,
  updateFilter,
  resetFilters,
  produitOptions,
  disciplineOptions,
  totalColumns = 0,
  visibleColumns = 0,
  allCardsExpanded,
  onToggleAllCards,
}) {
  const hasSearch = String(filters.q || "").trim().length > 0;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative w-full max-w-md sm:w-[360px]">
        <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-white/55" />
        <input
          type="text"
          value={filters.q}
          onChange={(event) => updateFilter("q", event.target.value)}
          placeholder="Rechercher club, contact, ville, note..."
          className="h-10 w-full rounded-xl border border-white/15 bg-white/10 py-2 pl-9 pr-3 text-sm font-medium text-white outline-none transition placeholder:text-white/50 hover:bg-white/15 focus:border-yellow-300 focus:bg-white/15 focus:ring-4 focus:ring-yellow-300/10"
        />
      </div>

      <select
        value={filters.produit_asso}
        onChange={(event) => updateFilter("produit_asso", event.target.value)}
        className="h-10 min-w-[200px] rounded-xl border border-white/15 bg-white/10 px-3 text-sm font-bold text-white outline-none transition hover:bg-white/15 focus:border-yellow-300"
      >
        <option className="text-slate-900" value="all">
          Toutes les applications
        </option>

        {(produitOptions || []).map((produit) => (
          <option className="text-slate-900" key={produit} value={produit}>
            {produit}
          </option>
        ))}
      </select>

      <select
        value={filters.discipline_asso}
        onChange={(event) =>
          updateFilter("discipline_asso", event.target.value)
        }
        className="h-10 min-w-[180px] rounded-xl border border-white/15 bg-white/10 px-3 text-sm font-bold text-white outline-none transition hover:bg-white/15 focus:border-yellow-300"
      >
        <option className="text-slate-900" value="all">
          Toutes les disciplines
        </option>

        {(disciplineOptions || []).map((discipline) => (
          <option
            className="text-slate-900"
            key={discipline}
            value={discipline}
          >
            {discipline}
          </option>
        ))}
      </select>

      <select
        value={filters.sort_relance}
        onChange={(event) => updateFilter("sort_relance", event.target.value)}
        className="h-10 min-w-[210px] rounded-xl border border-white/15 bg-white/10 px-3 text-sm font-bold text-white outline-none transition hover:bg-white/15 focus:border-yellow-300"
        title="Tri des cartes"
      >
        {CLIENT_SORT_OPTIONS.map((option) => (
          <option
            className="text-slate-900"
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>

      <button
        type="button"
        onClick={() =>
          updateFilter("favorite", filters.favorite === "true" ? "all" : "true")
        }
        className={`inline-flex h-10 items-center gap-2 rounded-xl px-3 text-sm font-bold text-white transition ${
          filters.favorite === "true"
            ? "bg-yellow-300/30 ring-1 ring-yellow-200/30"
            : "bg-white/10 hover:bg-white/15"
        }`}
      >
        <FaStar />
        {filters.favorite === "true" ? "Tous" : "Favoris"}
      </button>

      <button
        type="button"
        onClick={() =>
          updateFilter("hideEmptyColumns", !filters.hideEmptyColumns)
        }
        className={`inline-flex h-10 items-center gap-2 rounded-xl px-3 text-sm font-bold text-white transition ${
          filters.hideEmptyColumns || hasSearch
            ? "bg-sky-400/25 ring-1 ring-sky-200/25"
            : "bg-white/10 hover:bg-white/15"
        }`}
        title={
          hasSearch
            ? "Recherche active : seules les colonnes avec résultats sont affichées"
            : "Masquer les colonnes vides"
        }
      >
        <FaEyeSlash />
        {filters.hideEmptyColumns || hasSearch
          ? `Colonnes ${visibleColumns}/${totalColumns}`
          : "Masquer vides"}
      </button>

      <button
        type="button"
        onClick={onToggleAllCards}
        className={`inline-flex h-10 items-center gap-2 rounded-xl px-3 text-sm font-bold text-white transition ${
          allCardsExpanded
            ? "bg-emerald-400/25 ring-1 ring-emerald-200/25"
            : "bg-white/10 hover:bg-white/15"
        }`}
      >
        {allCardsExpanded ? <FaCompressAlt /> : <FaExpandAlt />}
        {allCardsExpanded ? "Tout diminuer" : "Tout agrandir"}
      </button>

      <button
        type="button"
        onClick={resetFilters}
        className="inline-flex h-10 items-center gap-2 rounded-xl bg-white/10 px-3 text-sm font-bold text-white transition hover:bg-white/15"
      >
        <FaTimes />
        Reset
      </button>
    </div>
  );
}
